import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faAlarmPlus as fasAlarmPus,
  faArrowDown as fasArrowDown,
  faArrowTurnDown as fasArrowTurnDown,
  faArrowDownToLine as fasArrowDownToLine,
  faArrowLeft as fasArrowLeft,
  faArrowLeftFromLine as fasArrowLeftFromLine,
  faArrowLeftToBracket as fasArrowLeftToBracket,
  faArrowLeftLong as fasArrowLeftLong,
  faArrowRight as fasArrowRight,
  faArrowRightFromBracket as fasArrowRightFromBracket,
  faArrowRightLong as fasArrowRightLong,
  faArrowRightToBracket as fasArrowRightToBracket,
  faArrowsRotate as fasArrowsRotate,
  faArrowsRotateReverse as fasArrowsRotateReverse,
  faArrowTrendUp as fasArrowTrendUp,
  faArrowUp as fasArrowUp,
  faArrowUpArrowDown as fasArrowUpArrowDown,
  faArrowUpRightDots as fasArrowUpRightDots,
  faArrowUpRightFromSquare as fasArrowUpRightFromSquare,
  faArrowUpToLine as fasArrowUpToLine,
  faBan as fasBan,
  faBell as fasBell,
  faBolt as fasBolt,
  faBriefcase as fasBriefcase,
  faBullhorn as fasBullhorn,
  faBuilding as fasBuilding,
  faCalendar as fasCalendar,
  faCalendarDay as fasCalendarDay,
  faCar as fasCar,
  faCarBurst as fasCarBurst,
  faCarWash as fasCarWash,
  faChartColumn as fasChartColumn,
  faChartLine as fasChartLine,
  faChartNetwork as fasChartNetwork,
  faChartSimple as fasChartSimple,
  // faChartDiagram as fasChartDiagram,
  faCheck as fasCheck,
  faCheckDouble as fasCheckDouble,
  faCheckToSlot as fasCheckToSlot,
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faChevronsDown as fasChevronsDown,
  faChevronsUp as fasChevronsUp,
  faChevronUp as fasChevronUp,
  faCircleCheck as fasCircleCheck,
  faCircleExclamation as fasCircleExclamation,
  faCircleInfo as fasCircleInfo,
  faCircleNotch as fasCircleNotch,
  faCirclePause as fasCirclePause,
  faCirclePlay as fasCirclePlay,
  faCircleQuestion as fasCircleQuestion,
  faCircleRight as fasCircleRight,
  faCircleUser as fasCircleUser,
  faCircleXmark as fasCircleXmark,
  faClipboardQuestion as fasClipboardQuestion,
  faClipboardUser as fasClipboardUser,
  faClock as fasClock,
  faClockRotateLeft as fasClockRotateLeft,
  faCloudSunRain as fasCloudSunRain,
  faConveyorBeltArm as fasConveyorBeltArm,
  faCodeCompare as fasCodeCompare,
  faCrop as fasCrop,
  faCrosshairs as fasCrosshairs,
  faCube as fasCube,
  faDeleteLeft as fasDeleteLeft,
  faDiagramNested as fasDiagramNested,
  faDiagramProject as fasDiagramProject,
  faDownToLine as fasDownToLine,
  faDownload as fasDownload,
  faDroplet as fasDroplet,
  faDropletSlash as fasDropletSlash,
  faEllipsis as fasEllipsis,
  faEnvelope as fasEnvelope,
  faExclamationCircle as fasExclamationCircle,
  faExclamationTriangle as fasExclamationTriangle,
  faExpand as fasExpand,
  faEye as fasEye,
  faEyeSlash as fasEyeSlash,
  faFaceAngry as fasFaceAngry,
  faFileExclamation as fasFileExclamation,
  faFileLines as fasFileLines,
  faFileMagnifyingGlass as fasFileMagnifyingGlass,
  faFilter as fasFilter,
  faFire as fasFire,
  faFileInvoiceDollar as fasFileInvoiceDollar,
  faFlag as fasFlag,
  faFlagSwallowtail as fasFlagSwallowtail,
  faFlask as fasFlask,
  faFloppyDisk as fasFloppyDisk,
  faFloppyDiskPen as fasFloppyDiskPen,
  faFolderOpen as fasFolderOpen,
  faGaugeCircleBolt as fasGaugeCircleBolt,
  faGear as fasGear,
  faGearComplex as fasGearComplex,
  faGears as fasGears,
  faGripDotsVertical as fasGripDotsVertical,
  faGripLines as fasGripLines,
  faHandPointer as fasHandPointer,
  faHashtag as fasHashtag,
  faHeadset as fasHeadset,
  faHouse as fasHouse,
  faIdCardClip as fasIdCardClip,
  faImage as fasImage,
  faInbox as fasInbox,
  faJugDetergent as fasJugDetergent,
  faKeySkeleton as fasKeySkeleton,
  faLayerGroup as fasLayerGroup,
  faLayerPlus as fasLayerPlus,
  faLightbulb as fasLightbulb,
  faLightEmergencyOn as fasLightEmergencyOn,
  faLink as fasLink,
  faList as fasList,
  faListCheck as fasListCheck,
  faListOl as fasListOl,
  faLocationDot as fasLocationDot,
  faLocationPlus as fasLocationPlus,
  faLock as fasLock,
  faNetworkWired as fasNetworkWired,
  faMagnifyingGlass as fasMagnifyingGlass,
  faMapLocation as fasMapLocation,
  faMapLocationDot as fasMapLocationDot,
  faMapPin as fasMapPin,
  faMessage as fasMessage,
  faMessagePen as fasMessagePen,
  faMessagePlus as fasMessagePlus,
  faMessageLines as fasMessageLines,
  faMicrochip as fasMicrochip,
  faMinus as fasMinus,
  faMoneyCheckDollar as fasMoneyCheckDollar,
  faMoon as fasMoon,
  faPause as fasPause,
  faPen as fasPen,
  faPenLine as fasPenLine,
  faPenNib as fasPenNib,
  faPenToSquare as fasPenToSquare,
  faPersonSeatReclined as fasPersonSeatReclined,
  faPhone as fasPhone,
  faPlay as fasPlay,
  faPlug as fasPlug,
  faPipe as fasPipe,
  faPlus as fasPlus,
  faQuestion as fasQuestion,
  faReceipt as fasReceipt,
  faRectangleHistory as fasRectangleHistory,
  faRepeat as fasRepeat,
  faReply as fasReply,
  faRightLeft as fasRightLeft,
  faRotate as fasRotate,
  faRotateLeft as faRotateLeft,
  faRotateReverse as fasRotateReverse,
  faRulerHorizontal as fasRulerHorizontal,
  faServer as fasServer,
  faShelves as fasShelves,
  faShelvesEmpty as fasShelvesEmpty,
  faShieldHalved as fasShieldHalved,
  faShieldKeyhole as fasShieldKeyhole,
  faSliders as fasSliders,
  faSlidersUp as fasSlidersUp,
  faSnooze as fasSnooze,
  faStar as fasStar,
  faSteeringWheel as fasSteeringWheel,
  faStop as fasStop,
  faSquareChevronRight as fasSquareChevronRight,
  faSquareDashedCirclePlus as fasSquareDashedCirclePlus,
  faSquareStar as fasSquareStar,
  faTableList as fasTableList,
  faTag as fasTag,
  faTimer as fasTimer,
  faToolbox as fasToolbox,
  faTools as fasTools,
  faTurnDownLeft as fasTurnDownLeft,
  faTrafficCone as fasTrafficCone,
  faTrashCan as fasTrashCan,
  faTriangleExclamation as fasTriangleExclamation,
  faTruck as fasTruck,
  faTruckClock as fasTruckClock,
  faTowerBroadcast as fasTowerBroadcast,
  faUpRightAndDownLeftFromCenter as fasUpRightAndDownLeftFromCenter,
  faUpToLine as fasUpToLine,
  faUp as fasUp,
  faDown as fasDown,
  faUser as fasUser,
  faUserCheck as fasUserCheck,
  faUserClock as fasUserClock,
  faUserGroup as fasUserGroup,
  faUserPlus as fasUserPlus,
  faUsers as fasUsers,
  faUserSecret as fasUserSecret,
  faUsersGear as fasUsersGear,
  faUserShield as fasUserShield,
  faUserSlash as fasUserSlash,
  faUsersViewfinder as fasUsersViewfinder,
  faUserTie as fasUserTie,
  faUserVneckHair as fasUserVneckHair,
  faUserXmark as fasUserXmark,
  faVials as fasVials,
  faWeightHanging as fasWeightHanging,
  faWrench as fasWrench,
  faX as fasX,
  faXmark as fasXmark,
  faLocationArrow as fasLocationArrow,
  faObjectGroup as fasObjectGroup,
  faObjectUngroup as fasObjectUngroup,
  faBellSlash as fasBellSlash,
  faHourglassClock as fasHourglassClock,
  faThumbsUp as fasThumbsUp,
  faScrewdriverWrench as fasScrewdriverWrench,
  faBoxOpen as fasBoxOpen,
  faPaperPlane as fasPaperPlane,
  faComments as fasComments
} from '@awesome.me/kit-8acc95c3ba/icons/classic/solid'

import {
  faArrowLeftFromLine as farArrowLeftFromLine,
  faArrowRight as farArrowRight,
  faArrowRightLong as farArrowRightLong,
  faArrowsRotate as farArrowsRotate,
  faArrowUpRightFromSquare as farArrowUpRightFromSquare,
  faBadgePercent as farBadgePercent,
  faBallotCheck as farBallotCheck,
  faBars as farBars,
  faBell as farBell,
  faBrowser as farBrowser,
  faCalendar as farCalendar,
  faCalendars as farCalendars,
  faCalendarCheck as farCalendarCheck,
  faCalendarClock as farCalendarClock,
  faCalendarXmark as farCalendarXmark,
  faCalendarExclamation as farCalendarExclamation,
  faCalendarCircleExclamation as farCalendarCircleExclamation,
  faCheck as farCheck,
  faCircle as farCircle,
  faChevronDown as farChevronDown,
  faChevronLeft as farChevronLeft,
  faChevronRight as farChevronRight,
  faChevronsDown as farChevronsDown,
  faChevronsUp as farChevronsUp,
  faCircleDollar as farCircleDollar,
  faCircleExclamation as farCircleExclamation,
  faCircleInfo as farCircleInfo,
  faCircleUser as farCircleUser,
  faChartPie as farChartPie,
  faClipboard as farClipboard,
  faClipboardList as farClipboardList,
  faClock as farClock,
  faClone as farClone,
  faCopy as farCopy,
  faCube as farCube,
  faEarthAmericas as farEarthAmericas,
  faEnvelope as farEnvelope,
  faFileContract as farFileContract,
  faFileImage as farFileImage,
  faFileImport as farFileImport,
  faFileInvoice as farFileInvoice,
  faFileLines as farFileLines,
  faFileXls as farFileXls,
  faFilter as farFilter,
  faGaugeMax as farGaugeMax,
  faGaugeMin as farGaugeMin,
  faGearComplex as farGearComplex,
  faGripLines as farGripLines,
  faHeadset as farHeadset,
  faHouse as farHouse,
  faImage as farImage,
  faMagnifyingGlassMinus as farMagnifyingGlassMinus,
  faMagnifyingGlassPlus as farMagnifyingGlassPlus,
  faMemo as farMemo,
  faMessageLines as farMessageLines,
  faMobile as farMobile,
  faMobileButton as farMobileButton,
  faMoneyCheckDollar as farMoneyCheckDollar,
  faMoneyCheckDollarPen as farMoneyCheckDollarPen,
  faPaperPlane as farPaperPlane,
  faPaste as farPaste,
  faPlus as farPlus,
  faSensorOn as farSensorOn,
  faQrcode as farQrcode,
  faReceipt as farReceipt,
  faRectangleHistory as farRectangleHistory,
  faShieldCheck as farShieldCheck,
  faSquareChevronRight as farSquareChevronRight,
  faSunBright as farSunBright,
  faTrashCan as farTrashCan,
  faUser as farUser,
  faUserHelmetSafety as farUserHelmetSafety,
  faXmark as farXmark,
  faDiagramProject as farDiagramProject
} from '@awesome.me/kit-8acc95c3ba/icons/classic/regular'

import {
  faYoutube as fabYoutube
} from '@awesome.me/kit-8acc95c3ba/icons/classic/brands'

import {
  faUserGroupSimple as fadUserGroupSimple
} from '@awesome.me/kit-8acc95c3ba/icons/duotone/solid'

import {
  faAlertsIcon as fakAlertsIcon,
  faReports1Icon as fakReports1Icon,
  faSiteCommandIcon as fakSiteCommandIcon,
  faSiteScanIcon as fakSiteScanIcon,
  faSiteTrackIcon as fakSiteTrackIcon,
  faSiteUniteIcon as fakSiteUniteIcon
} from '@awesome.me/kit-8acc95c3ba/icons/kit/custom'

library.add(
  fasGearComplex,
  farCircleExclamation,
  fasMapLocationDot,
  fasRightLeft,
  fasBan,
  fasCircleExclamation,
  fasArrowLeftLong,
  fasArrowLeftToBracket,
  fasArrowRightLong,
  fasChevronUp,
  fasPlus,
  fasPen,
  fasPenLine,
  fasPenToSquare,
  farCopy,
  farClipboard,
  fasXmark,
  fasTableList,
  fasJugDetergent,
  farClone,
  fasChevronDown,
  fasTrashCan,
  fasCircleCheck,
  fasArrowsRotate,
  farEarthAmericas,
  farEnvelope,
  farMobileButton,
  fasTools,
  fasWeightHanging,
  fasRulerHorizontal,
  fasListOl,
  fasMinus,
  farTrashCan,
  fasCheck,
  fasUserClock,
  farPaperPlane,
  fasUserSlash,
  fasUserShield,
  fasEnvelope,
  fasPhone,
  fasMoneyCheckDollar,
  fasUserPlus,
  fasUserCheck,
  fasReply,
  fasUser,
  fasUsersGear,
  fasUserTie,
  fasStar,
  fasStop,
  fasUserSecret,
  fasCircleUser,
  fasIdCardClip,
  fasClipboardQuestion,
  fasLocationArrow,
  farPaste,
  fasShieldHalved,
  fasFloppyDisk,
  fasExclamationCircle,
  fasHouse,
  fasChevronRight,
  fasUsersViewfinder,
  fasClipboardUser,
  fasHandPointer,
  fasUserXmark,
  fasListCheck,
  fasTriangleExclamation,
  fasEllipsis,
  fasMapPin,
  fasRotate,
  farChevronDown,
  farChevronRight,
  fasExclamationTriangle,
  farFileXls,
  farGaugeMin,
  farGaugeMax,
  fasSteeringWheel,
  fasPersonSeatReclined,
  fasArrowUpToLine,
  fasToolbox,
  fasArrowsRotateReverse,
  fasTrafficCone,
  fasDownToLine,
  fasUpToLine,
  fasRotateReverse,
  farReceipt,
  farCircleDollar,
  farCheck,
  farCircle,
  farArrowRightLong,
  fasHashtag,
  faRotateLeft,
  farGearComplex,
  farFileImport,
  fasChevronsUp,
  fasGripLines,
  fasChevronsDown,
  fasUsers,
  fasDroplet,
  fasDropletSlash,
  fasCar,
  fasEye,
  fasFilter,
  farFilter,
  fasCrosshairs,
  fasExpand,
  fasArrowLeft,
  fasArrowRight,
  fasBolt,
  farQrcode,
  fasChartColumn,
  fasSlidersUp,
  fasVials,
  fasSnooze,
  fasGear,
  farMemo,
  fasLocationDot,
  fasLocationPlus,
  farShieldCheck,
  farCalendar,
  farBallotCheck,
  fasUserGroup,
  farCalendarCheck,
  farChevronsUp,
  farGripLines,
  farChevronsDown,
  farClock,
  fasUserVneckHair,
  fasReceipt,
  farMessageLines,
  farMoneyCheckDollar,
  fabYoutube,
  fasArrowUpArrowDown,
  fasFileLines,
  fasFileMagnifyingGlass,
  farArrowUpRightFromSquare,
  farFileInvoice,
  farMoneyCheckDollarPen,
  farCircleInfo,
  fasX,
  fasCirclePlay,
  fasArrowTrendUp,
  fasCircleQuestion,
  farArrowsRotate,
  farPlus,
  farClipboardList,
  fasList,
  fasBriefcase,
  fasTruck,
  fasArrowUpRightFromSquare,
  fasGripDotsVertical,
  fasArrowDownToLine,
  fadUserGroupSimple,
  fasCircleNotch,
  farUser,
  farCalendarXmark,
  fasTimer,
  fasCirclePause,
  fasFire,
  fasLightEmergencyOn,
  fasFlag,
  fasFlagSwallowtail,
  fasCircleInfo,
  fasMessageLines,
  farXmark,
  farArrowRight,
  farBars,
  fasMapLocation,
  fasMoon,
  farSunBright,
  fasChevronLeft,
  farMagnifyingGlassMinus,
  farMagnifyingGlassPlus,
  farFileImage,
  fasFileExclamation,
  farImage,
  fasMagnifyingGlass,
  fasCircleXmark,
  farChevronLeft,
  fakSiteTrackIcon,
  fakSiteCommandIcon,
  fakSiteScanIcon,
  fakSiteUniteIcon,
  fakAlertsIcon,
  fakReports1Icon,
  fasGears,
  fasUpRightAndDownLeftFromCenter,
  fasHeadset,
  fasRectangleHistory,
  fasArrowRightFromBracket,
  fasArrowRightToBracket,
  farBrowser,
  farHouse,
  farHeadset,
  fasArrowUp,
  farRectangleHistory,
  fasCrop,
  farMobile,
  farCircleUser,
  farBell,
  fasCircleRight,
  fasClock,
  farFileLines,
  fasObjectGroup,
  fasObjectUngroup,
  fasBellSlash,
  fasUp,
  fasDown,
  fasHourglassClock,
  fasThumbsUp,
  fasScrewdriverWrench,
  fasBoxOpen,
  fasPaperPlane,
  fasComments,
  fasMagnifyingGlass,
  fasCheckToSlot,
  fasFloppyDiskPen,
  fasQuestion,
  farUserHelmetSafety,
  farCalendarCircleExclamation,
  fasPause,
  fasPlay,
  fasCarBurst,
  fasShelves,
  fasShelvesEmpty,
  farCalendarExclamation,
  fasWrench,
  fasFileInvoiceDollar,
  fasPenNib,
  fasInbox,
  fasTruckClock,
  fasClockRotateLeft,
  farCalendarClock,
  fasConveyorBeltArm,
  fasAlarmPus,
  farCalendars,
  fasRepeat,
  fasSquareChevronRight,
  fasClockRotateLeft,
  fasCodeCompare,
  fasArrowLeftFromLine,
  farArrowLeftFromLine,
  farSensorOn,
  fasCheckDouble,
  farDiagramProject,
  fasDiagramProject,
  farCube,
  fasDownload,
  fasImage,
  fasGaugeCircleBolt,
  farBadgePercent,
  fasDiagramNested,
  fasSquareDashedCirclePlus,
  fasSquareStar,
  fasArrowDown,
  fasArrowTurnDown,
  fasLightbulb,
  fasTurnDownLeft,
  fasCloudSunRain,
  farSquareChevronRight,
  fasTag,
  fasMicrochip,
  fasLayerGroup,
  fasLayerPlus,
  fasFlask,
  fasChartLine,
  fasDeleteLeft,
  fasCarWash,
  fasFaceAngry,
  fasShieldKeyhole,
  fasKeySkeleton,
  fasSliders,
  fasBuilding,
  fasMessage,
  fasMessagePen,
  fasMessagePlus,
  fasPlug,
  fasNetworkWired,
  fasLink,
  fasServer,
  fasBullhorn,
  fasEyeSlash,
  fasTowerBroadcast,
  fasEye,
  fasWrench,
  fasCircleInfo,
  fasLock,
  fasChartNetwork,
  farFileContract,
  fasCube,
  farChartPie,
  fasFolderOpen,
  fasArrowUpRightDots,
  fasBell,
  fasCalendar,
  fasCalendarDay,
  fasChartSimple,
  fasPipe,
  // fasChartDiagram
)